import { combineReducers } from '@reduxjs/toolkit';
import userReducer, { logout } from '../features/user/userSlice';
import ptLogsReducer from '../features/ptLogs/ptLogsSlice';
import coachPlayersReducer from '../features/coachPlayers/coachPlayersSlice';
import activitiesReducer from '../features/activities/activitiesSlice';
import coachActivitiesReducer from '../features/coachActivities/coachActivitiesSlice';
import otherCoachesActivitiesReducer from '../features/otherCoachesActivities/otherCoachesActivitiesSlice';
import coachLeaveReasonsSliceReducer from '../features/coachLeaves/coachLeaveReasonsSlice';

// Combine all reducers normally
const appReducer = combineReducers({
  user: userReducer,
  ptLogs: ptLogsReducer,
  coachPlayers: coachPlayersReducer,
  activities: activitiesReducer,
  coachActivities: coachActivitiesReducer,
  otherCoachesActivities: otherCoachesActivitiesReducer,
  coachLeaveReasons: coachLeaveReasonsSliceReducer,
});

// Root reducer to wipe entire Redux state on logout
const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    state = undefined; // Reset ALL slices to initial state
  }
  return appReducer(state, action);
};

export default rootReducer;